import Swiper from 'swiper/bundle';


document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.swiper-events', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        mousewheel: {
            releaseOnEdges: true,
        },
        direction: 'horizontal',
    });
})
